'use es6';

import { Record } from 'immutable';
const DEFAULTS = {
  archived: false,
  categoryId: null,
  currentState: '',
  id: 0,
  isDeleted: false,
  isPublished: false,
  mabMaster: false,
  name: '',
  screenshotPreviewUrl: '',
  subcategory: '',
  url: ''
};
export default class MABVariation extends Record(DEFAULTS) {
  static fromJS(data) {
    if (!data) {
      return new MABVariation();
    }

    const {
      archived,
      categoryId,
      currentState,
      deletedAt,
      id,
      isPublished,
      mabMaster,
      name,
      screenshotPreviewUrl,
      subcategory,
      url
    } = data;
    return new MABVariation({
      archived,
      categoryId,
      currentState,
      id,
      isDeleted: deletedAt > 0,
      isPublished,
      mabMaster,
      name,
      screenshotPreviewUrl,
      subcategory,
      url: mabMaster ? `${url}?hsNotRandom=true` : url
    });
  }

}